export default __webpack_public_path__ + "static/media/BeginningJournal2.238b8382.svg";